import type { Subscription } from '@/models/subscriptions.types'

const ACTIVE = 'active'

export function isActiveMembership(membership: Subscription): boolean {
  return membership.status === ACTIVE
}

export function thereIsAMembershipActive(memberships: Subscription[]): boolean {
  return memberships.some((membership) => membership.status === ACTIVE)
}
